module.exports = __webpack_public_path__ + "static/media/snappy-face.d502a2c4.svg";